import {getRequest, postRequest} from "../fetchWrapper";


/**
 * Récupération des informations du funérarium.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant du funérarium.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFunerariumGeneralInfos = (token, id) => {
    const url = `/api-v1/agency/${id}/funerarium/infos`
    return getRequest(url, token)
};

/**
 * Mise à jour des informations générales du funérarium.
 *
 * @param token Jeton d'authentification.
 * @param body Informations à mettre à jour.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateFunerariumMainInfos = (token, body) => {
    const url = `/api-v1/agency/funerarium/infos/main`
    return postRequest(url, body, token)
};

/**
 * Mise à jour des informations de l'adress du funérarium.
 *
 * @param token Jeton d'authentification.
 * @param body Informations à mettre à jour.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateFunerariumAddressInfos = (token, body) => {
    const url = `/api-v1/agency/funerarium/infos/address`
    return postRequest(url, body, token)
};

/**
 * Mise à jour des informations des horaires du funérarium.
 *
 * @param token Jeton d'authentification.
 * @param body Informations à mettre à jour.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateFunerariumScheduleInfos = (token, body) => {
    const url = `/api-v1/agency/funerarium/infos/schedule`
    return postRequest(url, body, token)
};